import script from "./TicketsDebiteurView.vue?vue&type=script&setup=true&lang=js"
export * from "./TicketsDebiteurView.vue?vue&type=script&setup=true&lang=js"

import "./TicketsDebiteurView.vue?vue&type=style&index=0&id=79f1be37&lang=css"

const __exports__ = script;

export default __exports__